import { createUsePermissions } from "./createUsePermissions";

export const useBlockCategoriesPermissions = createUsePermissions("pb.blockCategory");
